import { twMerge } from "tailwind-merge";

type Props = {
  name: string;
  /** Element id, defaulting to the name. Pass one per option when several radios
   * share a name, which is what makes them a group the browser can manage. */
  id?: string;
  label?: string;
  checked?: boolean;
  labelClassName?: string;
  inputClassName?: string;
  onCheck?: () => void;
};

const RadioButton = ({
  name,
  id = name,
  label = "",
  checked = true,
  labelClassName = "",
  inputClassName = "",
  onCheck = () => {}
}: Props) => {
  return (
    <div className="inline-flex items-center">
      <input
        id={`${id}-radio`}
        name={name}
        type="radio"
        className={twMerge(
          "peer h-4 w-4 cursor-pointer rounded-full border border-slate-300 accent-teal-500 checked:border-teal-500 transition-all",
          inputClassName
        )}
        checked={checked}
        onClick={() => onCheck?.()}
        onChange={() => {}}
      />
      {label && (
        <label
          data-testid="radio-label"
          htmlFor={`${id}-radio`}
          className={twMerge(
            "ml-2 text-txtPlaceholder cursor-pointer font-bold",
            labelClassName
          )}
        >
          {label}
        </label>
      )}
    </div>
  );
};

export default RadioButton;
